import { css } from 'lit';

export const iconStyles = css`
    :host {
        display: inline-block;
        transition: fill 0.2s, stroke 0.2s;
    }

    :host([size='small']) {
        width: 24px;
        height: 24px;
    }
    :host([size='medium']) {
        width: 32px;
        height: 32px;
    }
    :host([size='big']) {
        width: 48px;
        height: 48px;
    }
    :host([size='large']) {
        width: 64px;
        height: 64px;
    }

    :host svg {
        width: 100%;
        height: 100%;
    }
`;
